import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import api from "@/lib/api";

const FALLBACK = [
  { name: "Saans Chyawanprash", category: "Health Tonic", tagline: "Immunity & daily strength",
    image: "https://images.unsplash.com/photo-1471943311424-646960669fbc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { name: "Pure Aloe Vera Juice", category: "Juice", tagline: "Cold-pressed digestive care",
    image: "https://images.unsplash.com/photo-1600271886742-f049cd451bba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { name: "Premium Isabgol Husk", category: "Isabgol", tagline: "99% pure psyllium",
    image: "https://images.unsplash.com/photo-1633509817627-5a29634475af?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
  { name: "Ashwagandha Capsules", category: "Capsule", tagline: "Stress & vitality support",
    image: "https://images.unsplash.com/photo-1550572017-edd951b55104?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000" },
];

export default function BestSellers() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/products/trending")
      .then(({ data }) => setItems((data.products && data.products.length) ? data.products : FALLBACK))
      .catch(() => setItems(FALLBACK));
  }, []);

  const sellers = items.length ? items : FALLBACK;

  return (
    <section className="bg-[#f2ece4] py-20 md:py-28" data-testid="bestsellers-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <div className="eyebrow text-[#d46a1d]">Trending Now</div>
          <h2 className="mt-3 font-serif text-4xl tracking-tight text-[#202124] md:text-5xl">
            Products your customers keep coming back for
          </h2>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {sellers.map((s, i) => (
            <motion.div key={s.id || s.name}
              initial={{ opacity: 0, y: 22 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.07 }}
              className="group overflow-hidden rounded-2xl bg-white card-shadow" data-testid={`bestseller-${i}`}>
              <div className="aspect-square overflow-hidden bg-[#f9f8f5]">
                <img src={s.image} alt={s.name} loading="lazy" decoding="async"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-5">
                <div className="text-xs font-semibold uppercase tracking-wide text-[#1f5d3a]">{s.category}</div>
                <h3 className="mt-1 font-serif text-xl text-[#202124]">{s.name}</h3>
                <p className="mt-1 text-sm text-[#6b6a65]">{s.tagline}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
